var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 190,
    viewBox: "0 0 176 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_280)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7305 110.091C71.7305 112.066 73.3321 113.668 75.3077 113.668H100.38C102.355 113.668 103.957 112.066 103.957 110.091V97.8453C103.957 95.8696 102.355 94.2681 100.38 94.2681H75.3077C73.3321 94.2681 71.7305 95.8696 71.7305 97.8453V110.091ZM87.8438 100.734C89.6238 100.734 91.0664 102.182 91.0664 103.968C91.0664 105.753 89.6238 107.201 87.8438 107.201C86.0646 107.201 84.6211 105.753 84.6211 103.968C84.6211 102.182 86.0646 100.734 87.8438 100.734Z",
    fill: "url(#paint0_linear_16_280)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.466 49.0022C115.492 49.0022 105.218 45.8299 99.5872 43.1687C93.8536 40.458 91.6901 37.7322 91.4954 37.4754C90.3246 35.6375 87.7625 35.473 86.3634 37.2286C86.1755 37.4384 83.5671 40.2675 77.262 43.0705C71.175 45.7771 60.3288 49.0031 43.2227 49.0031C41.4426 49.0031 40 50.4499 40 52.2358V103.968C40 117.126 48.2983 128.59 63.9987 137.123C74.6662 142.92 86.5758 146 87.8439 146C88.9751 146 100.764 143.06 111.69 137.123C127.389 128.59 135.689 117.125 135.689 103.968V52.2358C135.689 50.4499 134.245 49.0022 132.466 49.0022V49.0022ZM110.402 116.9C110.402 118.686 108.96 120.134 107.18 120.134H68.5079C66.7287 120.134 65.2853 118.686 65.2853 116.9V91.0344C65.2853 89.2494 66.7287 87.8017 68.5079 87.8017H71.7406V77.9936C71.7406 69.4309 78.5577 61.9357 87.9412 61.9357C96.7674 61.9357 103.947 69.1396 103.947 77.9936C103.947 79.7794 102.504 81.2271 100.724 81.2271C98.9452 81.2271 97.5018 79.7794 97.5018 77.9936C97.5018 72.9414 93.5204 68.402 87.7465 68.402C82.4753 68.402 78.186 72.7056 78.186 77.9936V87.8017H107.18C108.96 87.8017 110.402 89.2494 110.402 91.0344V116.9Z",
    fill: "url(#paint1_radial_16_280)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_280",
    x: -14,
    y: -6,
    width: 203,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_280",
    x: 68.1532,
    y: 94.2681,
    width: 39.381,
    height: 26.5541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.57724
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.78862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_280",
    x1: 65.4832,
    y1: 94.2959,
    x2: 82.8546,
    y2: 117.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBFD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#7FBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16_280",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.69 47.5426) rotate(90) scale(132.119 114.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/Cyber.78e029e79821b077c14d30681ec1ea05.svg";
export { ForwardRef as ReactComponent };